import { IValidator, IUserRegistration, IValidations } from '@/interfaces';
import { isEmail, joinArr, hasUpper, hasLower, hasNumber } from '@/utils';

export class UserRegistrationValidator implements IValidator<IUserRegistration> {
  public isValid(item: IUserRegistration) {
    const errors: IValidations<IUserRegistration> = {};
    // Validate email
    if (!isEmail(item.email)) errors.email = ['Email must be a valid email address'];

    // Validate password
    if (item.password.length <= 6) errors.password = joinArr(errors.password, ['Password must exceed 6 characters']);
    if (!hasUpper(item.password)) errors.password = joinArr(errors.password, ['Password must contain at least one uppercase letter']);
    if (!hasLower(item.password)) errors.password = joinArr(errors.password, ['Password must contain at least one lowercase letter']);
    if (!hasNumber(item.password)) errors.password = joinArr(errors.password, ['Password must cotain at least one number']);

    // Validate confirm password
    if (item.password !== item.confirmPassword) errors.confirmPassword = ['Confirm Password and Password must be equal'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}